import { useEffect, PropsWithChildren } from 'react';

import { useSelector, useDispatch } from 'src/store';
import { fetchUserProductPermissionsAction } from 'src/store/slices/userProductPermissionsSlice';
import { authUserIdSelector, authRoleSelector, isLoggedInSelector } from 'src/store/selectors/authSelector';
import { selectedCompanyIdSelector } from 'src/store/selectors/companySelector';
import { loadedCompanyIdUserProductPermissionsSelector } from 'src/store/selectors/userProductPermissionsSelector';

import { PageLoading } from '@itm/shared-frontend/lib/components';

import { Role } from 'src/types';

function UserProductPermissionsProvider(props: PropsWithChildren<object>) {
  const dispatch = useDispatch();
  const isLoggedIn = useSelector(isLoggedInSelector);
  const userId = useSelector(authUserIdSelector);
  const userRole = useSelector(authRoleSelector);
  const selectedCompanyId = useSelector(selectedCompanyIdSelector);
  const loadedCompanyId = useSelector(loadedCompanyIdUserProductPermissionsSelector);

  const isProductAdmin = userRole === Role.SuperAdmin || userRole === Role.Support;
  const shouldFetch = Boolean(isLoggedIn && userId && selectedCompanyId && !isProductAdmin);

  useEffect(() => {
    if (!shouldFetch || !userId) return;
    dispatch(fetchUserProductPermissionsAction({ userId, companyId: selectedCompanyId }));
  }, [dispatch, shouldFetch, userId, selectedCompanyId]);

  // Permissions of the previously selected company must never reach route guards
  if (shouldFetch && loadedCompanyId !== selectedCompanyId) {
    return (
      <div className="container has-text-centered py-6">
        <PageLoading />
      </div>
    );
  }

  return <>{props.children}</>;
}

export default UserProductPermissionsProvider;
